import React from "react";

export default function MinusIcon({ id, width, height }) {
  return (
    <svg
      id={id}
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 8H12"
        stroke="#C90000"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/rifa/components/layout/icons/minusIcon.jsx